export default {
  DropAboveRow: "DropAboveRow",
  DropBelowRow: "DropBelowRow",
  DropOnRow: "DropOnRow",
  DropTopLevel: "DropTopLevel"
};
